/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Calculates the maximum number of thumbnails that can fit in a given width
 * for the redesigned PDP thumbnail carousel
 *
 * @param pixelWidth - The available width in pixels
 * @param isMobile - Whether the device is mobile (affects gap sizing)
 * @returns The maximum number of thumbnails that can fit
 */
export const calcMaxNumberOfThumbnails = ({
  pixelWidth,
  isMobile,
}: {
  pixelWidth: number;
  isMobile?: boolean;
}) => {
  const thumbnailWidth = 60;
  const thumbnailGap = isMobile ? 10 : 12;
  return Math.floor(pixelWidth / (thumbnailWidth + thumbnailGap));
};
